function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    canCreateProducts: null,
    canManageInstances: null,
    canManageWorkspaces: null,
    canPublishProducts: null,
    displayCurrency: "",
    isBanned: null,
    isPostpaid: null,
    nextTier: null,
    tier: undefined,
    usage: {
        instances: 0,
        workspaces: 0
    }
};
var currentAccountSlice = createSlice({
    initialState: initialState,
    name: "currentAccount",
    reducers: {
        addInstance: function(state) {
            state.usage.instances = state.usage.instances + 1;
        },
        addWorkspace: function(state) {
            state.usage.workspaces = state.usage.workspaces + 1;
        },
        deleteInstance: function(state) {
            if (state.usage.instances > 0) {
                state.usage.instances = state.usage.instances - 1;
            }
        },
        deleteWorkspace: function(state) {
            if (state.usage.workspaces > 0) {
                state.usage.workspaces = state.usage.workspaces - 1;
            }
        },
        resetCurrentAccount: function(state) {
            var _state_displayCurrency;
            return _object_spread_props(_object_spread({}, initialState), {
                displayCurrency: (_state_displayCurrency = state.displayCurrency) !== null && _state_displayCurrency !== void 0 ? _state_displayCurrency : initialState.displayCurrency
            });
        },
        setCurrentAccount: function(state, param) {
            var payload = param.payload;
            payload.tier !== undefined && (state.tier = payload.tier);
            payload.nextTier !== undefined && (state.nextTier = payload.nextTier);
            payload.displayCurrency && (state.displayCurrency = payload.displayCurrency);
            var _payload_canCreateProducts;
            "canCreateProducts" in payload && (state.canCreateProducts = (_payload_canCreateProducts = payload.canCreateProducts) !== null && _payload_canCreateProducts !== void 0 ? _payload_canCreateProducts : null);
            var _payload_canManageInstances;
            "canManageInstances" in payload && (state.canManageInstances = (_payload_canManageInstances = payload.canManageInstances) !== null && _payload_canManageInstances !== void 0 ? _payload_canManageInstances : null);
            var _payload_canManageWorkspaces;
            "canManageWorkspaces" in payload && (state.canManageWorkspaces = (_payload_canManageWorkspaces = payload.canManageWorkspaces) !== null && _payload_canManageWorkspaces !== void 0 ? _payload_canManageWorkspaces : null);
            var _payload_canPublishProducts;
            "canPublishProducts" in payload && (state.canPublishProducts = (_payload_canPublishProducts = payload.canPublishProducts) !== null && _payload_canPublishProducts !== void 0 ? _payload_canPublishProducts : null);
            var _payload_isBanned;
            "isBanned" in payload && (state.isBanned = (_payload_isBanned = payload.isBanned) !== null && _payload_isBanned !== void 0 ? _payload_isBanned : null);
            var _payload_isPostpaid;
            "isPostpaid" in payload && (state.isPostpaid = (_payload_isPostpaid = payload.isPostpaid) !== null && _payload_isPostpaid !== void 0 ? _payload_isPostpaid : null);
            if (payload.usage) {
                state.usage = payload.usage;
            }
        }
    }
});
var _currentAccountSlice_actions = currentAccountSlice.actions;
export var addInstance = _currentAccountSlice_actions.addInstance, addWorkspace = _currentAccountSlice_actions.addWorkspace, deleteInstance = _currentAccountSlice_actions.deleteInstance, deleteWorkspace = _currentAccountSlice_actions.deleteWorkspace, resetCurrentAccount = _currentAccountSlice_actions.resetCurrentAccount, setCurrentAccount = _currentAccountSlice_actions.setCurrentAccount;
export var currentAccountReducer = currentAccountSlice.reducer;

//# sourceMappingURL=current-account.js.map